import styled from "styled-components";
import { X } from "lucide-react";

const InfoModal = ({ icon, title, message, confirmText, onClose }) => {
  return (
    <ModalOverlay onClick={onClose}>
      <ModalCard onClick={(e) => e.stopPropagation()}>
        {icon && <ModalIcon>{icon}</ModalIcon>}
        {title && <ModalTitle>{title}</ModalTitle>}
        {message && <ModalMessage>{message}</ModalMessage>}
        <ModalCloseButton onClick={onClose}>
          <X size={14} />
        </ModalCloseButton>
        {confirmText && (
          <ConfirmButton onClick={onClose}>{confirmText}</ConfirmButton>
        )}
      </ModalCard>
    </ModalOverlay>
  );
};

export default InfoModal;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ModalCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 40px 32px 32px;
  max-width: 380px;
  width: 100%;
  background: ${({ theme }) => theme.menu.background};
  border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  border-radius: 16px;
  text-align: center;
`;

const ModalIcon = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: rgba(112, 105, 253, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(112, 105, 253, 0.7);
  margin-bottom: 4px;
`;

const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  margin: 0;
`;

const ModalMessage = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  margin: 0;
  line-height: 1.6;
`;

const ModalCloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;

  &:hover {
    background: ${({ theme }) => theme.sidebar.borderColor};
  }
`;

const ConfirmButton = styled.button`
  margin-top: 8px;
  padding: 10px 32px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  background: rgba(112, 105, 253, 1);
  border: none;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;
